module.exports = __webpack_public_path__ + "fonts/Font2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/reusableComponents/AutoGenerateSignature/fonts/Font2.ttf
// module id = 2430
// module chunks = 0